module.exports = __webpack_public_path__ + "img/cc-paypal.607f2030.svg";